
import { discountTypes } from "../configs/discountConfig"
import { taxTypes } from "../configs/taxConfig";
import { getInitialTaxValues } from "../schema/documents/taxSchema";

export const mergeSchema = (...schemas) => {
    const [first, ...rest] = schemas;

    const merged = rest.reduce(
        (mergedSchemas, schema) => mergedSchemas.concat(schema),
        first
    );

    return merged;
}

export const checkValueExists = ({
    searchFieldId = 'id',
    searchByIndex = false,
    valueReturnIfNotExist = "",
    dataSearch,
    valueToCompare
}) => {

    if (Array.isArray(dataSearch) === false) {
        return ""
    }

    // double check the dataSearch is not empty
    if (dataSearch && dataSearch.length <= 0) return valueReturnIfNotExist
    if (!valueToCompare) return valueReturnIfNotExist

    let check;

    if (searchByIndex) { // search by index no
        check = dataSearch.filter((i, index) => index === valueToCompare)
    } else {
        check = dataSearch.filter(i => i[searchFieldId] === valueToCompare)
    }

    // console.log('dataSearch', dataSearch, valueToCompare)

    if (check.length) {
        return valueToCompare
    }

    return valueReturnIfNotExist
}

// apply to all documents which have discounts and taxes
export const calculateSummaryRows = ({
    setFieldValue,
    formikValues: values,
    handleValueRow,
    handleValueTax
}) => {

    const {
        amount
    } = values?.discount ? values.discount : {}

    let newTotalAmount = 0

    // calculate the total rows
    if (values?.rows) {
        values.rows.forEach((item, index) => {

            // check the item?.price is object or value
            // console.log('typeof', typeof (item?.qty))

            let price = item.price ? item.price : 0;;
            let qty = 0;

            if (typeof (item?.qty) === "object") { // for nesteed schema object qty

                qty = item?.qty?.value ? item.qty.value : 0;

            } else { // for normal qty values

                qty = item.qty ? item.qty : 0;
            }

            let subTotal = parseFloat(price) * parseFloat(qty)

            if (handleValueRow) handleValueRow({ index, subTotal })

            newTotalAmount += subTotal

        })
    }

    // check the discount is enabled
    if (values?.discount) {
        if (values?.discount && values.discount.id === discountTypes.fixed.id) { // only allow fixed now
            newTotalAmount -= parseFloat(amount);
        } else {
            throw new Error(`Unsupported Discount Type : ${values.discount?.id}`)
        }
    }

    if (values?.tax) { // need tax

        // console.log('tax', values?.tax?.id)

        const taxValues = getInitialTaxValues(values.tax.id, newTotalAmount)

        if (handleValueTax) handleValueTax({ taxValues })

        // Object.keys(taxValues).forEach((e) => {
        //     setFieldValue(`tax.${e}`, taxValues[e])
        // })

        newTotalAmount += parseFloat(taxValues.amount)

    }

    return {
        totalAmount: newTotalAmount
    }

}